// extracted by mini-css-extract-plugin
export var buttons = "bracket-summary-module--buttons--bb340";
export var container = "bracket-summary-module--container--ac066";
export var left = "bracket-summary-module--left--bb3d6";
export var logo = "bracket-summary-module--logo--17993";
export var spin = "bracket-summary-module--spin--41904";